<template>
  <div class="login">
    <div class="login_form">

      <!-- <el-divider /> -->
      <p>{{'用户注册'}}</p>

      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-ruleForm">
        <el-form-item label="" prop="name">
          <el-input type="text" autocomplete="off" v-model="ruleForm.name" placeholder="请输入用户名">
            <template #prefix>
              <el-icon class="el-input__icon">
                <User />
              </el-icon>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item label="" prop="pass">
          <el-input type="password" autocomplete="off" v-model="ruleForm.pass" placeholder="请输入密码" show-password>
            <template #prefix>
              <el-icon class="el-input__icon">
                <Lock />
              </el-icon>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item label="" prop="checkPass">
          <el-input type="text" autocomplete="off" v-model="ruleForm.checkPass" placeholder="请输入手机号码">
            <template #prefix>
              <el-icon class="el-input__icon">
                <Iphone  />
              </el-icon>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item class="btns">
          <el-button type="primary" @click="submitForm('ruleForm')" :style="{ width: '400px',height:'35px' }">注册</el-button>
          <!--<el-button @click="resetForm('ruleForm')">重置</el-button>
           <el-button @click="get">测试</el-button> -->
        </el-form-item>
        <!-- <el-button class="btnclass44" link @click="btnclick001">已有账号？去登录</el-button> -->
      </el-form>

    </div>
  </div>
</template>

<script>

//import '/src/utils/axios.js'

import axios from 'axios'
import { Calendar, Search, User, Lock ,Iphone } from '@element-plus/icons-vue'
import { ElMessage, ElMessageBox } from 'element-plus'


// 配置请求的根路径
axios.defaults.baseURL= process.env.NODE_ENV === 'production' ? './' : '../' 

let q_url = process.env.NODE_ENV === 'production' ? 'temp_api.php' : '/api/NewQianXing/UserRegister/temp_api.php' 
let g_code;
   
   function get_code(){
    //获取邀请码
    var str = window.location.href;	//获取地址栏的url
         console.log('a0',str)
         let getqyinfo = str.split('?')[1];
         let getqys = new URLSearchParams('?'+getqyinfo)
         let getqycode = getqys.get('code') 
         getqycode = getqycode.substring(0,32);
         g_code= getqycode
         if(g_code==null){
          g_code='';
         }
         console.log('a01',g_code)
   }
		

export default {
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        if (this.ruleForm.checkPass !== "") {
          this.$refs.ruleForm.validateField("checkPass");
        }
        callback();
      }
    };

    var validatePass2 = (rule, value, callback) => {
      console.log('A10',value);
      if (value === "") {
        callback(new Error("请输入手机号码"));
      //} else if (value !== this.ruleForm.pass) {
        //callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };

   var validatePhone=(rule, value, callback)=> {
  const reg = /^(1[0-9]{10})$/;;
  if (value == '' || value == undefined || value == null) {
    callback(new Error('请输入正确的手机号码'));
  } else {
    if ((!reg.test(value)) && value != '') {
      callback(new Error('请输入正确的手机号码'));
    } else {
      callback();
    }
  }
};

    return {
      activeName: "second",
      ruleForm: {
        name: "",
        pass: "",
        checkPass: "",
      },
      rules: {
        name: [
          { required: true, message: "请输入您的名称", trigger: "blur" },
          { min: 2, max: 12, message: "长度在 2 到 12 个字符", trigger: "blur" },
        ],
        pass: [{ required: true, validator: validatePass, trigger: "blur" }],
        checkPass: [
          { required: true, validator: validatePhone, trigger: "blur" },
        ],
      },
    };
  },

  methods: {
    
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log('注册检查成功 执行注册=')
          /* this.$message({
            type: "success",
            message: "注册成功",
          });  */
          this.register();
          //this.activeName= 'first'

        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    btnclick001() {
      //this.activeName='first';
      console.log('110');
      this.$router.push('/login') //路由 下方弃用
      this.$emit("add", 'Login2'); //触发事件
    },
    register() {
    //注册账号
      //let url = 'http://47.98.194.29/api/user/register';
      //url='http://139.196.192.127/qxapi/user_manage_api.php?type=11';

      //let url = '/qxapi/user_manage_api.php';

      //let apiKey = '2WshDvM3a8682c1238af5a34f4eece5319e5a5637618bb7';
      let json = {
        user_name: this.ruleForm.name,
        user_pwd: this.ruleForm.pass
      }
      //console.log('555666', JSON.stringify(json));
      //let data = JSON.stringify(json);

      // let url = 'https://yesno.wtf/api';
      //let url ='/api/user/register'; //ok
      //url = '/api/NewQianXing/UserRegister/temp_api.php';
      var params = new URLSearchParams();
        params.append('type', '1');  //注册
        params.append('username', this.ruleForm.name);
        params.append('password', this.ruleForm.pass);
        params.append('phone',this.ruleForm.checkPass);
        params.append('code',g_code);
        //json协议头： application/json   post：application/x-www-form-urlencoded
        axios({
            method:'post',
            url:q_url,
            data:params,
            headers:{
              'Content-Type': 'application/x-www-form-urlencoded'
            }
        }).then(res => {
          console.log('77988', res.data);
          if(res.data=='注册成功！')
          {
            res.data += '请在PC客户端登录！';
          }
          this.MessageBox(res.data);
          /* if(res.data.code!=1000){
            this.MessageBox('注册失败！'+res.data.msg);
          }else
          {
            this.MessageBox('注册成功！');
          } */
          
          //ElMessageBox.alert('11','22');
          //this.data = res.data;
         
        
        })
      
/*       axios.post(q_url,
      params,
        {
          headers: {
            'Content-Type': 'application/json'
          }

        }
      )
        .then(res => {
          console.log('99988', res.data);
          if(res.data.code!=1000){
            this.MessageBox('注册失败！'+res.data.msg);
          }else
          {
            this.MessageBox('注册成功！');
          }         
          //ElMessageBox.alert('11','22');
          //this.data = res.data;
              
        }) */
    },
    MessageBox(text){
      ElMessageBox.alert(text, '提示', {
    // if you want to disable its autofocus
    // autofocus: false,
    confirmButtonText: 'OK',
    callback: (action) => {
      /* ElMessage({
        type: 'info',
        message: `action: ${action}`,
      }) */
    },
  
  })
    }

  },
  components: {
    Calendar,
    Search,
    User,
    Lock,
    Iphone 
  },
  mounted(){
    console.log('初始化');
    get_code();
  }
};



</script>
<style scoped lang="less">
.btns {
  display: flex;
  justify-content: flex-end;
}

.btnclass {
  margin-left: 270px;
  margin-top: 7px;
}

.login {
 // width: 100%;
  //height: 100vh;

  //background-image: url("../assets/login/A05.jpg"); //背景图
  //background-size: 100% 100vh;
   //background-size: 1920px 1200px;
  //background-position: center center;
 // overflow: auto;
//  position: relative;

  .login_form {
    width: 400px;
    height: 300px;
    position: absolute;
    left: 50%;
    top: 40%;
    margin-left: -200px;
    margin-top: -150px;
    padding: 10px;
    background: #fff;
    border-radius: 3px;
    box-shadow: 0 0 10px #ddd;

    .btns {
      display: flex;
      justify-content: flex-end;
    }
  }

  p {
    font-size: 24px;
    text-align: center;
    font-weight: 500;
    color: rgb(27, 146, 175);
  }

  .btnclass {
    margin-left: 200px;
    margin-top: 50px;
  }
}
</style>
